export const ANIMATION_DURATION = 3000;
export const GAME_RULES_HELP_KEYS_TURBO = new Array(18).fill(null).map((item, index) => index);
export const INFINITY_AUTO_BET = 'infinity';
export const AUTO_BET_COUNTS = [INFINITY_AUTO_BET, 25, 10, 5, 0];
export const GAME_CONTROLLER_TYPES_YET = {
  BETS: 'BETS',
};

export const SOCKET_METHODS = {
  TURBO_BET_ACCEPTED: 'TurboBetAccepted',
};

export const TURBO_GAME_ID = 33;
